<template>
  <button
    data-testid="button"
    v-access="access"
    :class="[className, { sending : isLoad }]"
    :type="typeBtn"
    :disabled="disabled"
    @click="emits('click')"
  >
    <svg v-if="type === 'link'" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.46492 17.5346C3.44276 17.5346 1.6197 16.3164 0.845724 14.4483C0.0717475 12.5801 0.499254 10.4296 1.92892 8.99953L4.05092 6.87753L5.46492 8.29153L3.34392 10.4125C2.58598 11.1705 2.28997 12.2752 2.5674 13.3106C2.84482 14.3459 3.65354 15.1546 4.6889 15.4321C5.72426 15.7095 6.82898 15.4135 7.58692 14.6555L9.70792 12.5345L11.1219 13.9495L9.00092 16.0705C8.06499 17.0111 6.79178 17.5382 5.46492 17.5346ZM6.17192 13.2415L4.75792 11.8275L11.8289 4.75653L13.2429 6.17053L6.17292 13.2405L6.17192 13.2415ZM13.9509 11.1205L12.5359 9.70653L14.6569 7.58553C15.4252 6.82986 15.7291 5.7202 15.4532 4.67851C15.1772 3.63683 14.3637 2.82318 13.3221 2.54698C12.2805 2.27077 11.1708 2.57445 10.4149 3.34253L8.29292 5.46353L6.87892 4.04953L9.00092 1.92753C10.956 -0.0105019 14.1099 -0.00359547 16.0565 1.94298C18.003 3.88956 18.01 7.04345 16.0719 8.99853L13.9509 11.1195V11.1205Z" fill="#2F3E4D" />
    </svg>
    <svg v-if="icon === 'back'" style="margin-right: 10px" width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 9L2 5L6 1" stroke="white" stroke-width="2" />
    </svg>
    <span>{{ text }}</span>
    <svg v-if="type === 'clear'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 7L17 17" stroke-width="2" />
      <path d="M17.0005 7L7.00049 17" stroke-width="2" />
    </svg>
  </button>
  <!-- template(v-if='isLoad')
      img.preloader(src='@/assets/icons/preloader.jpg') -->

</template>
<script setup>
import { defineProps, defineEmits, computed } from 'vue'

const props = defineProps({
  isLoad: {
    default: false,
  },
  text: {
    required: true,
    type: String,
  },
  type: {
    default: 'red',
    validator: val => {
      return (
        ['red', 'link', 'stroke', 'clear'].indexOf(val) !== -1
      )
    }
  },
  typeBtn: {
    default: 'button'
  },
  disabled: {
    default: false
  },
  access: {
    default: ''
  },
  icon: {
    default: ''
  }
})

const emits = defineEmits(['click'])

const className = computed(() => `button button-type_${props.type}`)
</script>
<style lang="scss" scoped>
.button {
  position: relative;
  border-radius: 4px;
  padding: 12px 20px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    background-color: $color-gray3;
    border-color: $color-gray3;
    cursor: auto;

    &:hover {
      background-color: $color-gray3;
      border-color: $color-gray3;
    }
  }

  &-type {

    &_link,
    &_stroke {
      background-color: white;
      border: 2px solid $color-active;

      &:hover {
        background-color: rbga($button-hover-color, 0.9);
      }
    }

    &_link {
      svg {
        margin-right: 12px;
      }
    }

    &_red {
      color: white;
      background-color: $color-active;
      border: 2px solid $color-active;

      &:hover {
        background-color: $button-hover-color;
        border-color: $button-hover-color;
      }
    }

    &_clear {
      background-color: transparent;
      border: none;
      color: $color-active;
      width: auto !important;
      padding: 0;
      display: flex;
      align-items: center;

      svg {
        margin-left: 5px;

        path {
          stroke: $color-active;
        }
      }
    }
  }

  &::before {
    content: '';
    position: absolute;
    right: 16px;
    top: calc(50% - 9px);
    width: 18px;
    height: 18px;
    border: 2px solid;
    display: none;
    border-left-color: transparent;
    border-right-color: transparent;
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.5s;
    animation: 0.8s linear infinite rotate;
  }

  &.sending{
    pointer-events: none;
    cursor: not-allowed;

    &::before {
      display: block;
      // transition-delay: 0.5s;
      transition-duration: 1s;
      opacity: 1;
    }
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
